import type { ActKc2Item, ActKc3ActsKc2SelectionItem } from 'gql/graphql';
import { formatDateToLocale } from 'utils';

import { useMemo } from 'react';

interface IUseWorkOrderActsKC2DataFilter {
    items?: ActKc2Item[];
    searchString?: string;
    filterValues: Record<string, string[]>;
}

export const getActNumberAndDate = (item: ActKc3ActsKc2SelectionItem | undefined) => {
    if (!item) {
        return 'Акт';
    }

    if (item.actKC2Number) {
        return `Акт №${item.actKC2IsCorrection ? item.actKC2FullNumber : item.actKC2Number} от ${formatDateToLocale(
            item.actKC2Date,
        )}`;
    }

    return 'Акт';
};

export const useAddOrEditActsKC3DataFilter = (props: IUseWorkOrderActsKC2DataFilter) => {
    const { items, searchString, filterValues } = props;
    const costGroup = filterValues?.costGroup;
    const constructionType = filterValues?.constructionType;
    const object = filterValues?.object;

    return useMemo(() => {
        const searched = searchString
            ? items?.filter((item) => {
                  const numberAndDate = getActNumberAndDate(item as any);
                  const constrType = item.object?.constructionType?.shortName;
                  const name = item.object?.name;
                  const search = searchString?.toLowerCase();

                  return (
                      numberAndDate.toLowerCase().includes(search) ||
                      constrType.toLowerCase().includes(search) ||
                      name.includes(search)
                  );
              })
            : items;

        if (!Object.keys(filterValues).length) {
            return searched;
        }

        return searched?.filter((item) => {
            const costGroupCondition = !costGroup || !costGroup.length || costGroup.includes(item.costGroup);
            const constructionTypeCondition =
                !constructionType ||
                !constructionType.length ||
                constructionType.includes(item.object?.constructionType?.shortName);
            const objectCondition = !object || !object.length || object.includes(item?.object?.name);

            return costGroupCondition && constructionTypeCondition && objectCondition;
        });
    }, [searchString, items, filterValues, costGroup, constructionType, object]);
};
